"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const script_1 = __importDefault(require("next/script"));
const utils_common_is_webview_1 = __importDefault(require("@gcloud-npm/utils.common.is-webview"));
const WebviewBridge = () => {
    if ((0, utils_common_is_webview_1.default)()) {
        return (react_1.default.createElement(script_1.default, { crossOrigin: true, strategy: "beforeInteractive", src: "https://unpkg.com/@tef-novum/webview-bridge/dist/webview-bridge-iife.min.js" }));
    }
    return null;
};
exports.default = WebviewBridge;
//# sourceMappingURL=index.js.map